<template lang="pug">
AuthorAudioJIT(:key="fileName" v-bind="courseAndFirm")
</template>

<script setup lang="ts">
import AuthorAudioJIT from './AuthorAudioJIT.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const fileName = computed(() => useRoute().params.fileName as string);

const courseAndFirm = computed(() => {
  const [courseIdStr = '', firmCodeStr = ''] = fileName.value
    .split('_')
    .reverse();

  return {
    courseId: Number(courseIdStr),
    firmCode: firmCodeStr || undefined
  };
});
</script>
